import * as React from 'react'
import { Container } from './Container'
import reasons1 from './images/reasons-1.png'
import reasons2 from './images/reasons-2.png'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import Image from 'next/image'

export function ReasonsToAttend() {
  return (
    <div className="bg-[#EEF2FF]">
      <Container className="relative py-14 lg:py-32 grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 ">
        <div className="flex flex-col gap-4 lg:gap-10 row-start-2 lg:row-start-auto h-[600px] md:h-[400px] lg:h-auto md:flex-row lg:flex-col">
          <div className="relative rounded-5xl overflow-hidden basis-2/3">
            <Image src={reasons1} alt="" fill className="object-cover" />
          </div>
          <div className="relative rounded-5xl overflow-hidden basis-1/3">
            <Image src={reasons2} alt="" fill className="object-cover" />
          </div>
        </div>
        <div className="text-primary-dark flex flex-col gap-7">
          <h2 className="font-body md:text-6xl lg:text-7xl sm:text-5xl text-4xl font-bold">
            Reasons to Attend
          </h2>
          <p className="font-bold text-2xl">
            Join the forefront of technology and innovation. Connect,
            collaborate, and catalyze change with industry leaders and emerging
            startups.
          </p>
          <p className="text-xl">
            The MarketX Ventures 2023 Technology & Innovation Summit is more
            than just a conference. It&apos;s a convergence of the brightest
            minds in technology and innovation, a platform for meaningful
            conversations, and a catalyst for transformative ideas. Join us as
            we explore the future of technology, from AI to blockchain, from
            sustainable solutions to groundbreaking startups.
          </p>
          <ol className="list-inside space-y-7 text-xl -indent-11 ml-11">
            <li>
              <CheckCircleIcon className="w-7 text-secondary-green inline mr-4" />
              <b>Uncover Investment Opportunities:</b> Discover emerging
              startups and potential investment opportunities in the fast-paced
              world of technology.
            </li>

            <li>
              <CheckCircleIcon className="w-7 text-secondary-green inline mr-4" />
              <b>Expand Your Network:</b> Take advantage of numerous networking
              opportunities to connect with like-minded professionals and
              potential collaborators.
            </li>

            <li>
              <CheckCircleIcon className="w-7 text-secondary-green inline mr-4" />
              <b>Stay Ahead of the Curve:</b> Gain insights into the latest
              technological advancements and innovative strategies to stay ahead
              in the ever-evolving tech landscape.
            </li>

            <li>
              <CheckCircleIcon className="w-7 text-secondary-green inline mr-4" />
              <b>Inspire and Get Inspired:</b> Share your ideas and get inspired
              by the groundbreaking work of others in the field.
            </li>

            <li>
              <CheckCircleIcon className="w-7 text-secondary-green inline mr-4" />
              <b>Exclusive Access:</b> Get exclusive access to investment
              opportunities; providing a unique opportunity to connect with
              startups and investors.
            </li>
          </ol>
        </div>
      </Container>
    </div>
  )
}
